import { useQuery } from '@tanstack/react-query'
import { fetchNoticeList, fetchFaqList } from '../services/api'

/**
 * 공지사항 목록을 가져오는 React Query 훅
 * @returns {Object} 공지사항 데이터와 로딩/에러 상태
 */
export const useNoticeList = () => {
	return useQuery({
		queryKey: ['noticeList'],
		queryFn: fetchNoticeList,
		select: (data) => {
			// 데이터 변환 로직
			return data.map((item, index) => {
				const id = index + 1
				const title = item.subject ?? '공지사항'
				const content = item.content ?? ''
				const dateObj = new Date(item.created_at || Date.now())
				const yyyy = dateObj.getFullYear()
				const mm = String(dateObj.getMonth() + 1).padStart(2, '0')
				const dd = String(dateObj.getDate()).padStart(2, '0')
				const date = `${yyyy}.${mm}.${dd}`

				return { id, title, content, date }
			})
		},
		staleTime: 5 * 60 * 1000, // 5분
		cacheTime: 10 * 60 * 1000, // 10분
	})
}

/**
 * FAQ 목록을 가져오는 React Query 훅
 * @param {string} category - 카테고리 필터
 * @returns {Object} FAQ 데이터와 로딩/에러 상태
 */
export const useFaqList = (category) => {
	return useQuery({
		queryKey: ['faqList', category],
		queryFn: () => fetchFaqList(category),
		select: (data) => {
			// 카테고리 매핑
			const categoryMap = {
				common: '공통',
				account: '계정',
				payment: '결제',
				service: '서비스',
				technical: '기술',
			}

			// 데이터 변환 로직
			return data.map((item, index) => {
				const mappedCategory = categoryMap[item.category] ?? ''
				const title = item.subject ?? '자주 묻는'
				const content = item.content ?? ''
				const dateObj = new Date(item.created_at || Date.now())
				const yyyy = dateObj.getFullYear()
				const mm = String(dateObj.getMonth() + 1).padStart(2, '0')
				const dd = String(dateObj.getDate()).padStart(2, '0')
				const date = `${yyyy}.${mm}.${dd}`

				return {
					id: index + 1,
					category: mappedCategory,
					title,
					content,
					date,
				}
			})
		},
		staleTime: 5 * 60 * 1000, // 5분
		cacheTime: 10 * 60 * 1000, // 10분
	})
}
